import React, { Component } from "react";
import PropTypes from "prop-types";

import style from "./Map.module.scss";

class LeafletInstance extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        return false;
    }

    render = () => {
        const { nodeId } = this.props;

        return (
            <div
                id={nodeId}
                className={style.mapInstance}
                style={{ position: "relative" }}
            ></div>
        );
    };
}

LeafletInstance.propTypes = {
    nodeId: PropTypes.string.isRequired,
};

export { LeafletInstance };
